import * as dev from "./dev.firebase.js";
import * as qa from "./qa.firebase.js";
import * as production from "./production.firebase.js";

const firebaseEnv = {
  "cavs.app": production,
  "qa-cavs.app": qa,
  "localhost:4200": dev,
}[window.location.host] || qa;

export const firebaseConfig = firebaseEnv.config;
export const shouldUseEmulator = firebaseEnv.shouldUseEmulator || false;
